import { render, staticRenderFns } from "./CountdownBanner.vue?vue&type=template&id=78907854&"
import script from "./CountdownBanner.vue?vue&type=script&lang=js&"
export * from "./CountdownBanner.vue?vue&type=script&lang=js&"
import style0 from "./CountdownBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports